import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import { ChangePasswordPage } from "./ChangePasswordPage";
import { LoginPage } from "./LoginPage";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, user, isLoading } = useAuth();

  // ローカル環境でもログインを必須にする（サーバー側がログインなしの API 呼び出しを拒否するため）
  // ローディング中は何も表示しない
  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "16px",
          color: "#666",
        }}
      >
        認証状態を確認中...
      </div>
    );
  }

  // 未認証の場合はログインページを表示
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  // 初回ログインの場合はパスワード変更を強制
  if (user?.isFirstLogin) {
    return <ChangePasswordPage required />;
  }

  // 認証済みユーザーはすべてのページにアクセス可能
  return <>{children}</>;
};
